import { getLanguage } from './index';

type JsonObject = Record<string, unknown>;

function asObject(value: unknown): JsonObject | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }
  return value as JsonObject;
}

function parseMetadata(metadata: JsonObject | string | undefined): JsonObject | null {
  if (!metadata) return null;
  if (typeof metadata === 'string') {
    try {
      const parsed = JSON.parse(metadata) as unknown;
      return asObject(parsed);
    } catch {
      return null;
    }
  }
  return asObject(metadata);
}

function resolveLeaf(value: unknown): string | null {
  const leaf = asObject(value);
  if (!leaf) return null;

  const lang = getLanguage();
  const direct = leaf[lang];
  if (typeof direct === 'string' && direct.trim().length > 0) {
    return direct;
  }

  const en = leaf.en;
  if (typeof en === 'string' && en.trim().length > 0) {
    return en;
  }

  for (const candidate of Object.values(leaf)) {
    if (typeof candidate === 'string' && candidate.trim().length > 0) {
      return candidate;
    }
  }

  return null;
}

export function localizeSkillName(skillId: string, fallback: string): string {
  void skillId;
  return fallback;
}

export function localizeSkillDescription(skillId: string, fallback: string): string {
  void skillId;
  return fallback;
}

export function localizeSkillTag(tag: string): string {
  return tag;
}

export function localizeItemName(
  itemId: string,
  metadata: JsonObject | string | undefined,
  fallback?: string
): string {
  const metadataObj = parseMetadata(metadata);
  const i18nName = resolveLeaf(metadataObj?.display_name_i18n);
  if (i18nName) return i18nName;

  const metadataName = metadataObj?.display_name;
  return typeof metadataName === 'string' && metadataName.trim().length > 0
    ? metadataName
    : (fallback ?? itemId);
}
